<template>
<div>
  <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(9999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"></picture-in-picture>
    <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(9999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
       v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
    <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h6 class="modal-title">{{$t('Manage Version')}} - {{fileInfo.slug_name}}</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
            <span aria-hidden="true">
              <cancel-icon class="close-icon" style="height: 30px !important;
                width: 30px !important;
                color: #fff;">
              </cancel-icon>
            </span>
          </button>
        </div>
        <div class="modal-body p-0">
            <ManageVersionCommonComponent :disableUpload="disableUpload" :fileInfo="selectedFileInfoToUpdateVersion" @previewVersions="previewVersions"></ManageVersionCommonComponent>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue";
import ManageVersionCommonComponent from "./ManageVersion.vue";
import pictureInPicture from "../files/MiniPlayer.vue";
import imagePreview from "../core/ImagePreviewDialog.vue";
import Utils from '../../components.utils.js';
import Constants from "../../components.constants.js";

export default {
  props:['fileInfo','disableUpload'],
  data(){
    return{
      selectedFileInfoToUpdateVersion:null,
      openPip:false,
      showOtherFilesPreviewDialog:false,
      assetDetailsToShowPip:{},
      selectedFileInfo:{}
    }
  },
  components:{
    'cancel-icon':cancelIcon,
    ManageVersionCommonComponent,
    "picture-in-picture":pictureInPicture,
    "ImagePreviewDialog":imagePreview
  },
  methods:{
    picPicZindex(zvalue, ref){
      if(this.$refs[ref].$el.style)this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
    },
    showAssetDetailsDockCloseMiniplayer(){
        if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
        this.openPip = true;
    },
    showAssetDetailsDockCloseMaximisedplayer(){
        if(this.isFullscreenPreviewAllowed()){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = true;
            return;
        }
    },
    openPictureInPicture(){
      if(this.isFullscreenPreviewAllowed()){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = true;
        return;
      }else{
        this.openPip = true;
        this.showOtherFilesPreviewDialog = false;
      }
    },
    isFullscreenPreviewAllowed(){
        let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
        return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
    },
    previewVersions(fileInfo){
        this.selectedFileInfo = {};
        this.selectedFileInfo = fileInfo;
        this.selectedFileInfo['file_name'] = fileInfo.files[0].path.split("/")[fileInfo.files[0].path.split("/").length - 1]
        if(this.$route && this.$route.name && ['update-ticket','task-info'].includes(this.$route.name) && this.$route.params && this.$route.params.tabType && this.$route.params.tabType == 'de'){
          this.$emit("openPreviewOfMedia",this.selectedFileInfo)
        }else{
          this.$nextTick(() => {
            this.openPictureInPicture()
          })
        }
    },
    closeMinimisedPlayer(){
        this.openPip = false;
        this.showOtherFilesPreviewDialog = false;
    },
    close(){
      this.$emit("close")
    },
  },
  created(){
    this.selectedFileInfoToUpdateVersion = this.fileInfo
  },
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
  max-width: 840px;
  width: 840px;
  height: 80%;
  margin: 0;
  padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
      cursor:text;
      display: inline-flex;
      flex-direction: column;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 10%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}
.modal-footer{
  padding: 5px 0px;
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    text-align: end;
    button{
        height: 38px;
        font-size:14px;
        width: inherit;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}
.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}
.top-nav-bar{
    text-align: center;
    background: $primary-background;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

.common-input-field{
    margin-inline-start: 3%;
    display: inline-block;
    width: 96%;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $secondary-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}
.input-text-field{
    height: 44px;
    width: 100% !important;
    padding-inline-start: 2%;
    padding-inline-end:2%;
    overflow: hidden;
}

  .add-border{
    border: $border-color;
  }

  .minMaxTextarea{
    min-height: 38px;
  }

  textarea:focus{
    outline: none;
    bottom: 0px;
    inset-inline-start: 0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
  }

  .dull-the-text{
    color: $dull-text-color;
  }

  ::placeholder {
    color: $dull-text-color !important;
  }

ul,.placeholder-file-name{
    list-style-type: none;
    padding: 0px;
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 10px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
    li{
        display:inline-flex;
        width: 97%;
        padding:2px;
        .key-style{
            color:$dull-text-color;
            width:17%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 80%;
            text-align: start;
            margin-inline-start: 11px;
            word-break: break-all;
        }
    }
}

.version-basic-info-wrapper{
    display: flex;
    flex-direction: column;
    padding:5px;
    position: relative;
    margin-bottom: 10px;
    .version-number-tag{
        border: $border-color;
        padding: 5px;
        width: 50px;
        height: 30px;
        font-size: 12px;
        border-radius: 10px;
        display: inline-flex;
        justify-content: center;
        background: #3a6e8b;
        margin: 0px 5px;
    }
    .latest-version-tag{
        border: $border-color;
        padding: 5px;
        width: 100px;
        height: 30px;
        font-size: 12px;
        border-radius: 10px;
        display: inline-flex;
        justify-content: center;
        background: #4d8b3a;
        margin: 0px 5px;
    }
}

.version-basic-info-wrapper:hover{
  border: $border-color;
  border-radius: 10px;
  background: #22272b;
  padding: 4px;
  .actions-on-manage-versions{
    visibility: visible;
    svg{
      margin-inline-end:5px;
    }
  }
}

.actions-on-manage-versions{
  visibility: hidden;
}

.actions-on-manage-versions{
  cursor: pointer;
  position: absolute;
  inset-inline-end: 0px;
  border: $border-color;
  width: auto;
  height: 35px;
  border-radius: 4px;
  top: 4px;
  inset-inline-end: 3px;
  padding: 0px 5px;
  background: $bg-color-on-hover;
  svg{
      margin:2px;
      background: #d1d2d31a;
      padding: 4px;
      height: 28px;
      width: 28px;
      border-radius: 4px;
      margin-inline-end: 5px;
      color: #c0c0c0;
  }
  svg:hover{
      background: #fdfeff54;
  }
}

.version-info-display{
  overflow: auto;
  padding-inline-start: 10px;
}

.tag-style{
    font-size:12px!important;
    height: 30px!important;
    display: inline-flex!important;
    margin: 2px!important;
    border: 1px solid $tags-border-color!important;
    border-radius: 10px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: center;
    width: auto!important;
    padding-inline-start: 1px!important;
    justify-content: center;
    padding-top: 4px!important;
    background: $tags-background-color;
    span {
        padding: 0px 8px !important;
        margin-inline-start: 0px !important;
        font-size:12px !important;
        border-radius: 15px !important;
        position: relative !important;
        top: 1px !important;
    }
}
.version-placeholder-tag{
  border: $border-color;
  padding: 4px;
  width: 125px;
  height: 30px;
  font-size: 15px;
  border-radius: 10px;
  display: inline-flex;
  justify-content: center;
  background: #d8b913fc;
  margin: 0px 5px;
  color: #000;
}
.media-preview-modal{
  top: 0px !important;
}

</style>
